import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

// Components
import BackButton from './BackButton';
import Icon from './Icon';
import Link from '../Steps/General/Link';
import Button from '../Steps/General/Button';
import { isFirstStep } from '../../utilities/section/sectionUtils';

let inputParams;

const NavigationContainer = ({
  id,
  label,
  actions,
  variant,
  values,
  columns,
  type,
  tracking,
  requiredData,
  userData,
  inline,
  subType,
  setValues,
  dataTealium,
  additionalClassName,
  icon,
  hideButton,
  conditionalLabel,
  dispatch,
  className,
  currentProgress,
  nextButtonStyle,
  nextButtonOnClick,
  nextButtonClassName,
  nextButtonDivClassName,
  nextButtonRef,
  nextButtonDisabled,
  nextButtonDataTealium,
  nextButtonLabel,
  nextButtonSubmitIcon,
  nextButtonType,
  nextButtonActionsButtons,
  nextButtonLinkUrl,
  nextButtonLinkTarget,
  nextButtonLinkTracking,
  nextButtonLinkTranslations,
  nextButtonLinkEncodeResponseData,
  nextButtonInputParams
}) => {

  let linkParams;
  if(nextButtonInputParams) {
    linkParams = nextButtonInputParams;
  } else {
    linkParams = {
      'label': nextButtonLabel,
      'link': nextButtonLinkUrl,
      'icon': nextButtonSubmitIcon,
      'target': nextButtonLinkTarget,
      'className': nextButtonClassName,
      'tracking': nextButtonLinkTracking,
      'dataTealium': nextButtonDataTealium,
      'translations': nextButtonLinkTranslations,
      'iconPos': 'after',
      'encodeResponseData': nextButtonLinkEncodeResponseData,
      'divClassName': nextButtonDivClassName
    }
  }

  let buttonParams = {
      id,
      label,
      actions,
      dispatch,
      'variant': variant || "primary",
      values,
      columns,
      type,
      tracking,
      requiredData,
      userData,
      inline,
      subType,
      setValues,
      dataTealium,
      additionalClassName,
      icon,
      hideButton,
      conditionalLabel
  }

  if (nextButtonActionsButtons?.length > 0) {
    nextButtonActionsButtons.map(actionProp => {
        inputParams = {
          ...formParams,
          ...actionProp,
          values,
        };
      }
    )
  }

  return (
      nextButtonStyle?.display !== "none" && 
      <div className={`NavigationContainer ${className}`} style={nextButtonStyle?.display && nextButtonStyle.display === "none" ? "display: " + nextButtonStyle.display : null}>
      {currentProgress && !currentProgress.hideBackButton && !isFirstStep(currentProgress) &&
        <BackButton
          className={"button NavigationContainerBackButton"}
          dispatch={dispatch}
          config={currentProgress?.backButtonConfig}
        />
      }
      {
        nextButtonType !== "link" && nextButtonType !== "button" && nextButtonActionsButtons?.length <= 0 &&
        <button
          style={nextButtonStyle}
          className={nextButtonClassName}
          onClick={nextButtonOnClick}
          ref={nextButtonRef}
          type="submit"
          disabled={nextButtonDisabled}
          data-tealium={nextButtonDataTealium}
        >
          <span>
            {nextButtonLabel}
            {nextButtonSubmitIcon &&
              <Icon icon="chevronLeft" fill="white"/>
            }
          </span>
        </button>
      }
      {
        nextButtonType !== "link" && nextButtonType !== "button" && nextButtonActionsButtons?.length > 0 &&
          actionsButtons.map(actionProp => {
            const inputParams = {
              ...formParams,
              ...actionProp,
              values,
            };
            const InputComponent = stepComponents[actionProp.type];
            <InputComponent {...inputParams}/>
          })
      }
      {
        nextButtonType && linkParams && nextButtonType === "link" &&
        <Link {...linkParams} />
      }
      {
        nextButtonType && buttonParams && nextButtonType === "button" &&
        <Button {...buttonParams} />
      }
    </div>
  );
};

export default compose(
  connect(state => {
    const {
      userData,
    } = state;
    return {
      userData,
    };
  })
)(NavigationContainer);

NavigationContainer.propTypes = {
  id: PropTypes.string,
  actions: PropTypes.array,
  variant: PropTypes.string,
  values: PropTypes.object,
  columns: PropTypes.string,
  type: PropTypes.string,
  tracking: PropTypes.array,
  requiredData: PropTypes.object,
  userData: PropTypes.object,
  inline: PropTypes.string,
  subType: PropTypes.string,
  setValues: PropTypes.func,
  dataTealium: PropTypes.string,
  additionalClassName: PropTypes.string,
  icon: PropTypes.string,
  hideButton: PropTypes.bool,
  conditionalLabel: PropTypes.object || PropTypes.string,
  currentProgress: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  displayImage: PropTypes.bool,
  compactLayout: PropTypes.bool,
  nextButtonStyle: PropTypes.object,
  nextButtonOnClick: PropTypes.func,
  nextButtonClassName: PropTypes.string,
  nextButtonDivClassName: PropTypes.string,
  nextButtonRef: PropTypes.func,
  nextButtonDisabled: PropTypes.bool,
  nextButtonDataTealium: PropTypes.string,
  nextButtonLabel: PropTypes.string,
  nextButtonSubmitIcon: PropTypes.bool,
  nextButtonType: PropTypes.string,
  nextButtonActionsButtons: PropTypes.array,
  nextButtonLinkUrl: PropTypes.string,
  nextButtonLinkTarget: PropTypes.string,
  nextButtonLinkTracking: PropTypes.array,
  nextButtonLinkTranslations: PropTypes.object,
  nextButtonLinkEncodeResponseData: PropTypes.string,
  nextButtonInputParams: PropTypes.object
};
